module.exports = __webpack_public_path__ + "static/media/tutorial_vi_1.13e79710.png";